import { defineComponent, onMounted } from 'vue';
import PopUp from '../PopUp/PopUp.vue';
import OptIn from './OptIn.class';
import { setupIncentive } from '../incentive-base';
import { setupComponent } from "@studyportals/vue-platform";

export default defineComponent({
	components: {
		PopUp,
	},
	props: {
		appIdentifier: String,
	},
	setup: () => {
		const component = setupIncentive(new OptIn());
		onMounted(component.mounted.bind(component));

		return setupComponent(component);
	},
});
